import {
  AbstractControl,
  FormArray,
  FormControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators

} from '@angular/forms';

import ActionTypesEnum from '@shared/enums/action-constant.enum';
import { OwnerEnum } from '@shared/enums/owner.enum';
import { NzModalRef } from 'ng-zorro-antd/modal';

export const validateFormGroup = (formGroup: FormGroup | FormArray): void => {

  Object.keys(formGroup.controls).forEach(field => {
    const control = formGroup.get(field);

    if (control instanceof FormControl) {
      control.markAsDirty();
      control.updateValueAndValidity();
    } else if (control instanceof FormGroup) {
      validateFormGroup(control);
    } else if (control instanceof FormArray) {
      validateFormGroup(control);
    }
  });

};

export const validateFormControl = (formControl: AbstractControl): void => {
  if (formControl instanceof FormControl) {
    formControl.markAsDirty();
    formControl.updateValueAndValidity();
  }
};

export const createFormGroupWithKey = (fields: Widget.Field[] = []): FormGroup => {

  const group: any = {};


  fields.forEach(field => {
    let formValue = null;
    const value = field?.data?.selections;
    if (field?.data?.content) {
      field.data.contentAll = field.data.content;
      field.data.content = field.data.content.length > 500 ? field.data.content.slice(0, 500) : field.data.content;

      if (field.data.contentAll && field.data.selections) {
        field.data.contentAll?.filter(item => field.data.selections instanceof Array ? field.data.selections.filter(selection => item.key === selection.key).length > 0 : item.key === field.data.selections.key)
          .forEach(selection => {
            if (!field.data.content.includes(selection)) {
              field.data.content.push(selection);
            }
          });
      }
    }

    if (value) {
      formValue = value instanceof Array ? value.map(item => item.key) : value;

      if (field.multiSelect !== undefined && field.multiSelect === false && field.type !== 'date') {
        formValue = formValue[0];
      }

      if (field.type === 'date') {
        formValue = new Date(formValue);
      }

    }

    group[field.key] = createFormControl(formValue, field.validators && field.validators.indexOf('required') > -1
      ? (field.validators.indexOf('invisible') === -1 || (field.validators.indexOf('invisible') > -1 && field.invisible !== true)
        ? Validators['required']
        : null)
      : null
    );
  });
  return new FormGroup(group);

};

export const createFormGroup = (fields: Widget.Field[] = []): FormGroup => {

  const group: any = {};

  fields.forEach(field => {
    let formValue = null;
    const value = field?.data?.selections;
    if (field?.data?.content) {
      field.data.contentAll = field.data.content;
      field.data.content = field.data.content.length > 500 ? field.data.content.slice(0, 500) : field.data.content;
      if (field.data.contentAll && field.data.selections) {
        field.data.contentAll?.filter(item => field.data.selections instanceof Array ? field.data.selections.filter(selection => item.key === selection.key).length > 0 : item.key === field.data.selections.key)
          .forEach(selection => {
            if (!field.data.content.includes(selection)) {
              field.data.content.push(selection);
            }
          });
      }
    }

    if (value) {
      formValue = value instanceof Array ? value.map(item => item) : value;

      // if (field.multiSelect !== undefined && field.multiSelect === false &&  field.type !== 'date') {
      //  formValue = formValue[0];
      // }

      if (field.type === 'date') {
        formValue = new Date(formValue);
      }

    }

    group[field.key] = createFormControl(formValue, field.validators && field.validators.indexOf('required') > -1
      ? (field.validators.indexOf('invisible') === -1 || (field.validators.indexOf('invisible') > -1 && field.invisible !== true)
        ? Validators['required']
        : null)
      : null
    );
  });



  return new FormGroup(group);

};

export const createFormControl = (value, validators: Validators = []): FormControl => new FormControl(value, validators);

export const updateFormValidators = (fields: Widget.Field[] = [], form: FormGroup): FormGroup => {
  fields.forEach(field => {
    form.get(field.key).setValidators(
      field.validators && field.validators.indexOf('required') > -1
        ? (field.validators.indexOf('invisible') === -1 || (field.validators.indexOf('invisible') > -1 && field.invisible !== true)
          ? Validators['required']
          : null)
        : null
    );
  });

  return form;
};

export const updateFieldData = (data: any, modal: NzModalRef, genericFormDataService, scopeId: string, customEventService?): void => {
  const innerComponent = modal.getContentComponent();
  const { field, form, value: selectedValue } = data;
  function ifExistsSelectionForPaginationData(targetField) {
    if (targetField.widgetFieldListener?.params && targetField.data.selections !== null) {
      let targetUrl = targetField.widgetFieldListener.url;

      for (const [key, value] of Object.entries(targetField.widgetFieldListener.params)) {
        const prerequisites = innerComponent.selectedFields.get(key);
        let replaceValue ='';
        replaceValue = typeof prerequisites === 'string' ? prerequisites : prerequisites.join('','');
        targetUrl = targetUrl.replace(value, replaceValue);
      }

      targetField.loading = true;
      targetUrl = targetUrl.concat('&value=' + targetField.data.selections);
      genericFormDataService.getData(targetUrl, scopeId).subscribe(response => {
        targetField.loading = false;
        if (response) {
          response.forEach(item => {
            if (targetField.data.selections === item.key) {
              if (targetField.data.content.filter(d => d.key === item.key).length < 1) {
                targetField.data.content.push(item);
              }

              const newData = {
                field: targetField,
                form,
                value: item.key
              };
              updateFieldData(newData, modal, genericFormDataService, scopeId, customEventService);
            }
          });
        }
      }, error => {
        targetField.data.content = null;
        targetField.loading = false;
        console.log('error occurred while fetching field data', error);
      });

    }
  }

  // for service based data operations to fill or flush fields
  field.affects.forEach(affect => {
    const targetField = innerComponent.fields.find(item => item.key === affect);
    if (!!selectedValue && selectedValue.length && targetField && targetField?.data?.params) {
      let targetUrl = targetField.data.url;


      for (const [key, value] of Object.entries(targetField.data.params)) {
        const prerequisites = innerComponent.selectedFields.get(key);
        let replaceValue ='';
        replaceValue = prerequisites;
        // replaceValue = typeof prerequisites === 'string' ? prerequisites : prerequisites[prerequisites.length - 1];
        targetUrl = targetUrl.replace(value, replaceValue);
      }

      targetField.loading = true;
      targetField.loadingData = true;
      genericFormDataService.getData(targetUrl, scopeId).subscribe(response => {
        targetField.loading = false;
        targetField.loadingData = false;
        targetField.data.content = response.length > 500 ? response.slice(0, 500) : response;
        targetField.data.contentAll = (field.key === 'repository' ? field.data.contentAll.concat(response) : response);
        ifExistsSelectionForPaginationData(targetField);

        const alreadyExist = targetField.data.content.find(item => item.key === targetField.data.selections);
        if (!alreadyExist) {
          const selectedItem = targetField.data.contentAll.find(item => item.key === targetField.data.selections);
          if (selectedItem !== undefined) {
            targetField.data.content[0] = selectedItem;
          }
        }

        targetField.data.defaultContent = targetField.data.content;

        if (typeof targetField.data.selections !== 'string' && targetField.data.selections) {
          const selections = targetField.data.selections.filter(selection =>
            response.some(item => item.key === selection.key)
          );

          const val = selections instanceof Array
            ? selections.map(item => item.key)
            : (selections instanceof Object ? selections.key : selections);
          if (val) {
            if (innerComponent.addForm) {
              innerComponent.addForm.get(targetField.key)?.setValue(val instanceof Array && !val.length ? null : val);
            } else {
              innerComponent.addAnalysisForm.get(targetField.key)?.setValue(val instanceof Array && !val.length ? null : val);
            }

          }
        } else if (typeof targetField.data.selections === 'string') {
          const val = targetField.data.selections;

          if (val) {
            if (innerComponent.updateDeploymentAnalyticForm) {
              innerComponent.updateDeploymentAnalyticForm.get(targetField.key)?.setValue(val instanceof Array && !val.length ? null : val);
            } else {
              innerComponent.addAnalysisForm.get(targetField.key)?.setValue(val instanceof Array && !val.length ? null : val);
            }
          }
        }

        // setTimeout(() => { //DAS-3289 maddesi için yorum satırına alındı
        if (targetField.data.content && targetField.data.content.length === 1 && !targetField.key.startsWith('deploymentAnalytics')) {
          form.get(targetField.key)?.setValue(targetField.multiSelect ? [targetField.data.content[0].key] : targetField.data.content[0].key);
          const eventType = targetField.multiSelect ? [targetField.data.content[0].key] : targetField.data.content[0].key;
          customEventService?.announceEvent(
            ActionTypesEnum.WIDGET_CREATE_ONE_ITEM_SELECTED,
            { event: eventType, field: targetField }
          );
        }
        // },6000);
      }, error => {
        targetField.data.content = null;
        targetField.loading = false;
        console.log('error occurred while fetching field data', error);
        if (error.status === 500) {
          targetField.data.content = null;
          targetField.loading = false;
        }
        ;
      });

    } else {
      if (targetField?.data?.url) {
        targetField.data.content = null;
      }
    }

    (form as FormGroup).get(affect)?.setValue(null);
    (form as FormGroup).get(affect)?.setErrors(null);
    (form as FormGroup).get(affect)?.markAsPristine();

  });

  if (selectedValue && field.multiSelect) {
    const foundField = innerComponent.fields.find(item => item.key === field.key);

    if (foundField) {
      foundField.data.selections = selectedValue.map(item => {
        return {
          key: item
        };
      });
    }
  }

  // date related operations
  if (field.key === 'period') {
    const isCustomDateActive = selectedValue === 'FROM';

    (form as FormGroup).get('from').setValidators(isCustomDateActive ? [Validators.required] : null);
  }
};

// keyup Function

export const updateKeyupFieldData = (data: any, modal: NzModalRef, genericFormDataService, scopeId: string, customEventService?): void => {
  const innerComponent = modal.getContentComponent();
  const { field, form, value: selectedValue } = data;

  // for service based data operations to fill or flush fields
  if (field.widgetFieldListener.params) {
    let targetUrl = field.widgetFieldListener.url;

    for (const [key, value] of Object.entries(field.widgetFieldListener.params)) {
      const prerequisites = innerComponent.selectedFields.get(key);
      let replaceValue ='';
      replaceValue = typeof prerequisites === 'string' ? prerequisites : prerequisites.join(',');
      targetUrl = targetUrl.replace(value, replaceValue);
    }

    field.loading = true;
    targetUrl = targetUrl.concat('&value=' + selectedValue);
    genericFormDataService.getData(targetUrl, scopeId).subscribe(response => {
      field.loading = false;
      field.data.content = response;
      field.data.contentAll = (field.key === 'repository'  || field.key === 'application'  ) ? field.data.contentAll.concat(response) : response;

    }, error => {
      field.data.content = null;
      field.loading = false;
      console.log('error occurred while fetching field data', error);
    });

  } else {
    if (field?.data.url) {
      field.data.content = null;
    }
  }
};


// Custom Validators
export const uniqueArrayValidator: ValidatorFn = (control: FormArray): ValidationErrors | null => {

  const isUnique = control.controls.every((controlItem, index) => {
    // decide every item is single on the array
    // if not set errors on that control
    const unique = control.value.indexOf(controlItem.value) === index;

    if (!unique) {
      controlItem.setErrors({ unique: true });
    }

    return unique;
  });

  return !isUnique ? { unique: true } : null;
};


export const exceptLastValidator: ValidatorFn = (control: FormArray): ValidationErrors | null => {

  const isValid = control.controls.every((controlItem, index) => {
    // decide every item is not null except the last one
    const validOrNot = control.controls.length !== ++index ? !!controlItem.value : true;

    if (!validOrNot) {
      controlItem.setErrors({ required: true });
    }

    return validOrNot;
  });

  return !isValid ? { required: true } : null;
};

// data modifications for request objects

export const requestObjectMapper = (formData: any, fields: any[]): any => {
  // maps request.formData object values as {key, label} objects or {key, label}[]
  for (const [key, value] of Object.entries(formData)) {
    const matchingField = fields.find(field => field.key === key);

    if (matchingField && matchingField.data) {
      if (!matchingField.data.contentAll && matchingField.data.content && matchingField.data.content.length) {
        matchingField.data.contentAll = matchingField.data.content;
      }

      if (matchingField.data.contentAll && matchingField.data.contentAll.length) {
        if (matchingField.multiSelect) {
          formData[key] = matchingField.data.contentAll
            .filter(listItem => {
              return value ? (value as any[])
                .includes(listItem.key) : false;
            });
        } else {
          formData[key] = matchingField.data.contentAll.find(listItem => value === listItem.key);
        }
      }
    }

    if (matchingField.type === 'input' && !formData[key]) {
      delete formData[key];
    }
  }

  return formData;
};

export const passwordValidator = (control: FormControl) => {
  const passwordPattern = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/;

  if (!control.value) {
    return { error: true, required: true };
  }
  if (control.value.match(passwordPattern)) {
    return {};
  } else {
    return { error: true, passwordValidator: true };
  }
};
export const uniqueNameValidator = (array, data) => {

  return (control: AbstractControl): { [key: string]: boolean } | null => {
    if (!control.value) {
      return { error: true, required: true };
    }

    if (array.some(item => item.name.toLowerCase() === control.value.toLowerCase() && item.id !== data.id)) {
      return { error: true, notUnique: true };
    }

    return {};
  };
};

export const ownerObjectUpdater = (formData) => {

  if (!formData.owners) {
    formData.owners = [
      {
        type: OwnerEnum.USER,
        ids: formData.users
      },
      {
        type: OwnerEnum.TEAM,
        ids: formData.teams
      }
    ];

    delete formData.users;
    delete formData.teams;

    return formData;
  }

  formData.owners.forEach(item =>
    item.ids = item.type === OwnerEnum.USER ? formData.users : formData.teams);

  return formData;
};

export const nextFieldData = (data: any, modal: NzModalRef, genericFormDataService, scopeId: string, customEventService?): void => {
  const innerComponent = modal.getContentComponent();
  const { field, form } = data;

  // for service based data operations to fill or flush fields

  const targetField = field;

  if (field?.data?.url) {


    let targetUrl = targetField.data.url;

    for (const [key, value] of Object.entries(targetField.data.params)) {
      const prerequisites = innerComponent.selectedFields.get(key);
      let replaceValue ='';

      if (prerequisites?.key) {
        targetUrl = targetUrl.replace(value, prerequisites.key);
      } else {
        replaceValue = typeof prerequisites === 'string' ? prerequisites : prerequisites.join('','');
        targetUrl = targetUrl.replace(value, replaceValue);
      }
    }
    targetField.loading = true;
    genericFormDataService.getData(targetUrl, scopeId).subscribe(response => {
      targetField.loading = false;
      targetField.data.content = response.length > 500 ? response.slice(0, 500) : response;
      targetField.data.contentAll = response;
      const localSelected = innerComponent.localSelectedFields.get(field.key);
      if (targetField?.data?.content) {
        if (localSelected === undefined) {
          let selections = targetField?.data?.selections;
          if (selections === undefined || selections.length === 0) {
            selections = targetField?.data?.content.filter(item => item.selected);
          }
          if (selections) {
            field.data.selections = selections;
            if (selections instanceof Array && selections.length === 1 && field.multiSelect === false) {
              innerComponent.selectedFields.set(field.key, selections[0]);
            } else if (selections instanceof Object) {
              innerComponent.selectedFields.set(field.key, selections);
            } else {
              innerComponent.selectedFields.set(field.key, field.multiSelect ? selections : selections[0]);
            }
          }
        } else {
          innerComponent.selectedFields.set(field.key, localSelected);
        }
      }
    }, error => {
      targetField.data.content = null;
      targetField.loading = false;
      console.log('error occurred while fetching field data', error);
    });

  } else {
    if (targetField?.data.url) {
      targetField.data.content = null;
    }

  }
};

export const updateV2FieldData = (data: any, modal: NzModalRef, genericFormDataService, scopeId: string, customEventService?): void => {
  const innerComponent = modal.getContentComponent();
  const { field, form, value: selectedValue } = data;
  field.data.selections = selectedValue;
  // for service based data operations to fill or flush fields

  field.affects.forEach(affect => {
    const targetField = innerComponent.fields.find(item => item.key === affect);
    if (targetField) {
      targetField.data.selections = innerComponent.selectedFields.get(targetField.key);
    }

    if (!!selectedValue && (selectedValue?.key || selectedValue.length) && targetField && targetField.data.params) {

      let targetUrl = targetField.data.url;

      for (const [key, value] of Object.entries(targetField.data.params)) {
        const prerequisites = innerComponent.selectedFields.get(key);
        if (prerequisites.key) {
          targetUrl = targetUrl.replace(value, prerequisites.key);
        } else if (Array.isArray(prerequisites)) {
          targetUrl = targetUrl.replace(value, prerequisites[prerequisites.length - 1].key);
        }

      }

      targetField.loading = true;

      genericFormDataService.getData(targetUrl, scopeId).subscribe(response => {
        targetField.loading = false;
        if (targetField.addToList) {
          if (targetField.data.content) {
            targetField.data.content = targetField.data.content.concat(response);
            targetField.data.contentAll = targetField.data.contentAll.concat(response);
          } else {
            targetField.data.content = response;
            targetField.data.contentAll = response;
          }
        } else {
          targetField.data.content = response;
          targetField.data.contentAll = response;
        }


        if (typeof targetField.data.selections !== 'string' && targetField.data.selections) {
          let selections = targetField.data.selections;
          if (selections instanceof Array) {
            selections = targetField.data.selections.filter(selection =>
              response.some(item => item.key === selection.key)
            );
          } else {
            const val = selections instanceof Array
              ? selections.map(item => item.key)
              : (selections instanceof Object ? selections : selections);

          }
        }

        // setTimeout(() => { //DAS-3289 maddesi için yorum satırına alındı
        if (targetField.data.content && targetField.data.content.length === 1) {
          form.get(targetField.key)?.setValue(targetField.multiSelect ? [targetField.data.content[0].key] : targetField.data.content[0].key);
          customEventService?.announceEvent(
            ActionTypesEnum.WIDGET_CREATE_ONE_ITEM_SELECTED,
            {
              event: targetField.multiSelect ? [targetField.data.content[0]] : targetField.data.content[0],
              field: targetField
            }
          );
        }
        // },6000);
      }, error => {
        targetField.data.content = null;
        targetField.loading = false;
        console.log('error occurred while fetching field data', error);
      });

    } else {
      if (targetField?.data?.url) {
        targetField.data.content = null;
      }
    }

    (form as FormGroup).get(affect)?.setValue(null);
    (form as FormGroup).get(affect)?.setErrors(null);
    (form as FormGroup).get(affect)?.markAsPristine();

  });

  if (selectedValue !== undefined) {
    const foundField = innerComponent.fields.find(item => item.key === field.key);
    if (foundField) {
      foundField.data.selections = selectedValue;
    }


  }
};

function uniqueArray2(arr) {
  const a = [];
  for (let i = 0, l = arr.length; i < l; i++) {
    if (a.indexOf(arr[i]) === -1 && arr[i] !=='') {
      a.push(arr[i]);
    }
  }
  return a;
}

function ArrayUniqueByKey(array: any[]): any[] {
  const uniqueArray = array.reduce((acc, current) => {
    if (!acc.some(item => item.key === current.key)) {
      acc.push(current);
    }
    return acc;
  }, []);
  return uniqueArray;
}
export const updateQwiserV2FieldData = (
  data: any,
  modal: NzModalRef,
  genericFormDataService,
  scopeId: string,
  customEventService?
): void => {
  const innerComponent = modal.getContentComponent();
  const { field, form, value: selectedValue } = data;
  if (form.value === undefined) {
    return;
  }
  field.data.selections = selectedValue || [];
  field.affects.forEach(async (affect) => {
    const targetField = innerComponent.fields.find((item) => item.key === affect);
    if (targetField) {
      form.get(affect)?.setValue(null);
      form.get(affect)?.setErrors(null);
      form.get(affect)?.markAsPristine();

      const oldValue = innerComponent.localSelectedFields.get(targetField.key);
      const ss =uniqueArray2( [...(oldValue || []), ...(innerComponent.selectedFields.get(targetField.key) || [])]);

      targetField.data.selections = ss;
      if (!!selectedValue && (selectedValue?.key || selectedValue.length) && targetField && targetField.data.params) {
        let targetUrl = targetField.data.url;
        for (const [key, value] of Object.entries(targetField.data.params)) {
          const prerequisites = innerComponent.selectedFields.get(key);
          if (prerequisites?.key) {
            targetUrl = targetUrl.replace(value, prerequisites.key);
          } else if (Array.isArray(prerequisites)) {
            const cc = prerequisites.reduce((acc,item)=>{
              acc.push(item.key)
              return acc;
            },[]);
            targetUrl = targetUrl.replace(value, cc);
          }
        }


        const content = [...(targetField.data.content || []), ...ss];
        const contentAll = [...(targetField.data.contentAll || []), ...ss];

        targetField.loading = false;

        const response = await genericFormDataService.getData(targetUrl, scopeId).toPromise();
        targetField.data.content = ArrayUniqueByKey([...content, ...response]);
        targetField.data.contentAll = ArrayUniqueByKey([...contentAll, ...response]);

        if (targetField.addToList) {
          targetField.data.selections =  targetField.data.content;
        } else if (targetField.key !== 'branch') {
          targetField.data.content = response;
          targetField.data.contentAll = response;
        }

        if (targetField.key === 'branch') {
          innerComponent.selectField(targetField.data.content.filter(item => item.selected), targetField);
        }

      }
    }
  });
};


export const createV2FormGroup = (fields: Widget.Field[] = []): FormGroup => {
  const group: any = {};
  fields.forEach(field => {
    let formValue = null;
    const value = field.data.selections;
    if (field.data.content) {
      field.data.contentAll = field.data.content;
      if (field.data.contentAll && field.data.selections) {
        field.data.contentAll?.filter(item => field.data.selections instanceof Array ? field.data.selections.filter(selection => item.key === selection.key).length > 0 : item.key === field.data.selections.key)
          .forEach(selection => {
            if (!field.data.content.includes(selection)) {
              field.data.content.push(selection);
            }
          });
      }
    }

    if (value !== undefined) {
      formValue = value;

      if (field.type === 'date') {
        formValue = new Date(formValue);
      }

      if (value instanceof Array && value.length === 1 && field.multiSelect === false) {
        formValue = value[0];
      }
    }

    group[field.key] = createFormControl(formValue, field.validators && field.validators.indexOf('required') > -1
      ? (field.validators.indexOf('invisible') === -1 || (field.validators.indexOf('invisible') > -1 && field.invisible !== true)
        ? Validators['required']
        : null)
      : null
    );
  });
  return new FormGroup(group);
};


